









import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { Const } from '@/const';
import { Data } from "@/data/data";
import { DebugHelper } from "@/helper/debugHelper";
import { ResourceHelper } from "@/helper/resourceHelper";
import { CookieHelper } from "@/helper/cookieHelper"
import { JsonHelper } from "@/helper/jsonHelper";
import { EncryptionHelper } from "@/helper/encryptionHelper"
import { RequestHelper } from "@/helper/requestHelper";
import { SnsHelper } from "@/helper/snsHelper";
import { NativeHelper } from '@/helper/nativeHelper';

import { Document } from '@/model/document2/document';
import { InsertionData } from '@/model/document2/insertionData/insertionData';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';

@Component({
    components: {
    }
})
export default class Sns_m extends Vue {
    
    private mounted(){
        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        window.addEventListener("message", this.messageEvent);
    }
    
    private destroyed(){
        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        window.removeEventListener("message", this.messageEvent);
    }

    private messageEvent(message)
    {
        DebugHelper.trace("messageEvent");

        try
        {
            var jsonData = JSON.parse(message.data);

            // 選択した投稿リストを受け取る
            if(jsonData.onDoCommand == "decisionSelect")
            {
                var value = jsonData.value;
                var userName = jsonData.userName;
                var userIcon = jsonData.userIcon;
                var snsType = jsonData.snsType; // 1: twitter, 2: facebook
                var applyInfo = jsonData.applyInfo;

                DebugHelper.trace("value: ");
                DebugHelper.trace(value);
                DebugHelper.trace("userName: " + userName);
                DebugHelper.trace("userIcon: " + userIcon);
                DebugHelper.trace("snsType: " + snsType);
                
                this.$store.getters.snsInfo.snsContentsLength = value.length;
                DebugHelper.trace(this.$store.getters.snsInfo.snsContentsLength);

                this.applySnsContentsToDesign(value, userName, userIcon, snsType, applyInfo);
            }
            else if(jsonData.onDoCommand == "mounted")
            {
                NativeHelper.sendNativeEvent("view_mounted", { view : "Sns" });
            }
            else if(jsonData.onDoCommand == "selectContentsCancel")
            {
                NativeHelper.sendNativeEvent("select_sns_contents_cancel", {});
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
    }

    // コマンド処理
    private processExecCommand(parameterParent : any)
    {
        var command : string = "";
        try
        {
            command = parameterParent.command;
            var parameter : any = parameterParent.parameter;

            DebugHelper.trace("command Sns: " + command);
            
            if(command == "import_document_sns")
            {
                DebugHelper.trace("import document start");
                // ドキュメント読み込み
                try
                {
                    var json = parameter.document;
                    var jsonData = JSON.parse(json);
                    var importDocument = Document.createFromJsonData(jsonData);
                    if(importDocument.useInsertion)
                    {
                        // 差し込みは読み込まない
                        NativeHelper.sendNativeEvent("import_document_error", { about : "useInsertion" });
                        return;
                    }

                    // パラメータ反映
                    if(parameter.page != null) { importDocument.currentPageIndex = parameter.page; }
                    if(parameter.isReverse != null) { importDocument.setSurface(parameter.isReverse == "true"); }
                    if(parameter.position != null)
                    {
                        var page = importDocument.pageList[importDocument.currentPageIndex];
                        page.currentDesignPosition = parameter.position;
                    }

                    // ドキュメント反映
                    this.$store.dispatch("setDocument", importDocument);

                    NativeHelper.sendNativeEvent("import_document_completed", { });
                }
                catch(eDoc)
                {
                    // ドキュメント読み込み独自でエラーチェックする
                    NativeHelper.sendNativeEvent("import_document_error", { about : "invalid" });
                }
            }
            else if(command == "set_sns_type")
            {
                // snsType
                this.setSnsType(parameter.snsType);
            }
            else if(command == "set_timeline")
            {
                // 投稿
                this.setTimeline(parameter.timeline);
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
            NativeHelper.sendNativeEvent("error_exec_command", { command : command, error : ex });
        }
    }

    // デザインにSNSのデータを反映させる
    private applySnsContentsToDesign(contents : any, userName : string, userIcon : string, snsType : number, applyInfo : { [key : string] : boolean })
    {
        // テンプレートIDの決定
        var templateId = this.getTemplateId(snsType);
        // テンプレート取得
        var postData = { id : "" + templateId };
        RequestHelper.get("get_template_new_content", postData, (response) =>
        {
            try
            {
                var jsonObject = JSON.parse(response);
                var templateContents = jsonObject.data.templateContents;
                // ドキュメントを作成する
                var documentJson = EncryptionHelper.compositeIfNeeded(templateContents);
                var templateDoc = Document.createFromJsonData(JSON.parse(documentJson));

                var currentDocument = this.$store.getters.document;
                // 反映
                SnsHelper.applyContents(contents, userName, userIcon, currentDocument, templateDoc, applyInfo, () =>
                {
                    // 完了処理
                    NativeHelper.sendNativeEvent("apply_sns_contents_finished", {});
                });
            }
            catch(e)
            {
                DebugHelper.trace(e);
            }
        }, () =>
        {
            DebugHelper.trace("request error");
        });
    }

    private getTemplateId(snsType : number)
    {
        var id = id = Const.TEMPLATE_ID_FACEBOOK;
        if(snsType == 1) { id = Const.TEMPLATE_ID_TWITTER; }
        else if(snsType == 2) { id = Const.TEMPLATE_ID_FACEBOOK; }
        return id;
    }

    private onDoCommand(command: string, param, any){
        // if(command == "decision"){
        //     this.decision(param);
        // }
    }

    // 取得するSNSをiframeに送る
    private setSnsType(snsType: number){
        DebugHelper.trace("snsType");
        DebugHelper.trace(snsType);
        var command = {
            onDoCommand : "setSnsType",
            value : snsType
        };
        this.doPostMessage(command);
    }

    private setTimeline(jsonData){
        DebugHelper.trace("setTimeline");
        DebugHelper.trace(jsonData);        

        var command = {
            onDoCommand : "setTimeline",
            value : jsonData
        };
        this.doPostMessage(command);
    }

    private doPostMessage(command : {}){
        var ifrm = (<any>this.$refs.iframe).contentWindow;
        ifrm.postMessage(JSON.stringify(command), "*");
    }

    private get iframeURL(){
        var url = Const.IFRAME_URL_BASE + "sns/index.html";
        return url;
    }
 
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigButtonColor(){
        var style = {
            backgroundColor: this.userConfigColor
        };
        return style;
    }
    
    private get userConfigBackgroundColor(){
        var style = {
            background: this.$store.getters.userConfigColors.backgroundColor
        };
        return style;
    }
}
